import {
    UserProfileData,
    UserData,
    UserUpdateForm,
    UserListQuery,
    UserCreateForm,
    UserResponse,
    UserListResponse,
    UserStatus,
    EntryTypeListItemData,
    EntryTypeListResponse,
    DoctorProfileData,
    DoctorProfileDataResponse,
    UserUpdateAdditionalDataParams,
    UserLocaleQuery,
} from 'chaika-frontend-types/frontend-cms';

import { axios } from '@lib/axios';

const BASE_URL = '/api/user';

export class UserApi {
    public static async get(id: string, params?: UserLocaleQuery): Promise<UserProfileData> {
        const res = await axios.get<UserResponse>(`${BASE_URL}/${id}`, { params });

        return res.data.user;
    }

    public static async getSiteProfile(id: string): Promise<DoctorProfileData | null> {
        try {
            const res = await axios.get<DoctorProfileDataResponse>(`${BASE_URL}/${id}/profile`);

            return res.data.profile;
            // eslint-disable-next-line sonarjs/no-ignored-exceptions
        } catch (e) {
            return null;
        }
    }

    public static async getUserEntryTypes(id: string): Promise<EntryTypeListItemData[]> {
        const { data } = await axios.get<EntryTypeListResponse>(`${BASE_URL}/${id}/entry-type`);
        const forbiddenTypes = new Set(['Анализы', 'Системная']);

        return data.entryTypes.filter(item => !forbiddenTypes.has(item.type));
    }

    public static async getList(params?: UserListQuery): Promise<UserData[]> {
        const res = await axios.get<UserListResponse>(BASE_URL, { params });

        return res.data.users;
    }

    public static async update(id: string, user: UserUpdateForm): Promise<void> {
        await axios.put(`${BASE_URL}/${id}`, { user });
    }

    public static async updateStatus(id: string, status: UserStatus): Promise<void> {
        await axios.put(`${BASE_URL}/${id}/status`, { user: { status } });
    }

    public static async addUserRole(id: string, roleId: string): Promise<void> {
        await axios.post(`${BASE_URL}/${id}/role`, { assignment: { roleId } });
    }

    public static async updateAdditionalData(
        id: string,
        additionalParams: UserUpdateAdditionalDataParams,
    ): Promise<void> {
        await axios.put(`${BASE_URL}/${id}/additional-data`, { user: additionalParams });
    }

    public static async removeUserRole(id: string, roleId: string): Promise<void> {
        await axios.delete(`${BASE_URL}/${id}/role/${roleId}`);
    }

    public static async create(user: UserCreateForm): Promise<void> {
        await axios.post(BASE_URL, { user });
    }
}

export { BASE_URL as USER_BASE_URL };
